import VehicleTypeActionTypes from "./vehicle-type.types";

const INITIAL_STATE = {
	// general
	error: null,
	loading: false,
	allVehicleType: [],
};

const vehicleTypeReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case VehicleTypeActionTypes.CLEAR_ERROR:
			return {
				...state,
				error: null,
			};
		case VehicleTypeActionTypes.FETCH_ALL_VEHICLE_TYPE_START:
		case VehicleTypeActionTypes.CREATE_VEHICLE_TYPE_START:
		case VehicleTypeActionTypes.UPDATE_VEHICLE_TYPE_START:
		case VehicleTypeActionTypes.DELETE_VEHICLE_TYPE_START:
			return {
				...state,
				loading: true,
			};
		case VehicleTypeActionTypes.FETCH_ALL_VEHICLE_TYPE_FAILURE:
		case VehicleTypeActionTypes.CREATE_VEHICLE_TYPE_FAILURE:
		case VehicleTypeActionTypes.UPDATE_VEHICLE_TYPE_FAILURE:
		case VehicleTypeActionTypes.DELETE_VEHICLE_TYPE_FAILURE:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		case VehicleTypeActionTypes.CREATE_VEHICLE_TYPE_SUCCESS: 
		case VehicleTypeActionTypes.UPDATE_VEHICLE_TYPE_SUCCESS: 
		case VehicleTypeActionTypes.DELETE_VEHICLE_TYPE_SUCCESS:{
			return {
				...state,
				loading: false,
			};
		}
		case VehicleTypeActionTypes.FETCH_ALL_VEHICLE_TYPE_SUCCESS: {
			return {
				...state,
				allVehicleType: action.payload,
				loading: false,
			};
		}
		default:
			return state;
	}
};

export default vehicleTypeReducer;
